export interface LotDataFieldExistingValue {
  value: string | null
  isAcceptable: boolean
  operatorType: string | null
}

const DEFINED_DATA_FIELD_TYPE = 'defined'

/**
 * Values to list under "Data Field Acceptable Values" in the lot detail modal.
 * A Defined field stores one row per option, flagged acceptable or not, so only
 * the acceptable options are listed (legacy parity: lotDetail.component.ts).
 * Number and linear fields store rule rows and are listed as-is.
 */
export function visibleLotDataFieldValues(
  dataFieldType: string,
  existingValues: LotDataFieldExistingValue[],
): LotDataFieldExistingValue[] {
  if (dataFieldType !== DEFINED_DATA_FIELD_TYPE) return existingValues
  return existingValues.filter((v) => v.isAcceptable)
}
